import { APP_ENV } from './constants.ts';

// Lang

export function isDev() {
    return process.env.NODE_ENV === 'development' || APP_ENV !== 'production';
}
